import React, { useState, useEffect } from "react";
import menuData from "./menuData";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import {
    HomeOutlined,
    BorderOutlined,
    ShopOutlined,
    FileOutlined,
    LineChartOutlined,
    ProfileOutlined,
    DatabaseOutlined,
    DollarCircleOutlined
} from '@ant-design/icons';
import { useModel } from "../../models";
import { getUserMenuAll } from "../../utils/constants";
const { SubMenu } = Menu;

const IconMap = {
    "HomeOutlined": <HomeOutlined />,
    "BorderOutlined": <BorderOutlined />,
    "ShopOutlined": <ShopOutlined />,
    "FileOutlined": <FileOutlined />,
    "LineChartOutlined": <LineChartOutlined />,
    "ProfileOutlined": <ProfileOutlined />,
    "DatabaseOutlined": <DatabaseOutlined />,
    "DollarCircleOutlined": <DollarCircleOutlined />
};

const AppMenu = (data) => {
    return (
        data.hasOwnProperty("children") && data.children.length > 0 ? <SubMenu
            key={data.id}
            title={
                <span>
                    {IconMap[data.icon]}
                    <span>{data.name}</span>
                </span>
            }
        >
            {
                data.children.map(el => AppMenu(el))
            }
        </SubMenu> :
            <Menu.Item key={data.id} icon={IconMap[data.icon]}>
                <Link to={{ pathname: data.path, state: { id: data.id } }}>{data.name}</Link>
            </Menu.Item>
    );
};

export default function () {
    const [{ menuSelected },] = useModel("nav");
    const [newArr, setNewArr] = useState([]);

    useEffect(() => {
        let menuAuth = getUserMenuAll() ?? [];
        let arr = menuData.filter(item => menuAuth.indexOf(item.path) > -1);
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].children && arr[i].children.length > 0) {
                arr[i].children = arr[i].children.filter(item => menuAuth.indexOf(item.path) > -1);
            }
        }
        console.log(arr);
        setNewArr(arr);
    }, [])

    return (
        <Menu
            theme="dark"
            mode="inline"

            selectedKeys={[menuSelected]}
            defaultSelectedKeys={['1']}
        >
            {
                newArr.length > 0 && newArr.map(el => AppMenu(el))
            }
        </Menu>
    )
}